<template>
  <div>
    <table width="100%">
      <colgroup>
        <col
          :style="
            'width: ' +
            (method == 'order' || method == 'byp_arrear' ? 40 : 60) +
            '%; min-width: ' +
            (method == 'order' || method == 'byp_arrear' ? 40 : 60) +
            '%;'
          "
        />
        <col style="width: 10%; min-width: 10%" />
        <col style="width: 10%; min-width: 10%" />
        <col
          v-if="method == 'order' || method == 'byp_arrear'"
          style="width: 20%; min-width: 20%"
        />
        <col style="width: 15%; min-width: 15%" />
      </colgroup>
      <thead class="ant-table-thead">
        <tr>
          <th>商品信息</th>
          <th>单价</th>
          <th>数量</th>
          <th
            v-if="method == 'order' || method == 'byp_arrear' || method == 'mz'"
          >
            服务
          </th>
          <th>金额合计</th>
        </tr>
      </thead>
      <tbody class="ant-table-tbody">
        <template v-for="(store, index) in goodsList">
          <tr :key="`store_${store.id + index}`">
            <td colspan="6">
              <div class="flex_v_center">
                <img
                  src="~@/assets/images/basic/ic_shop.png"
                  width="16"
                  height="16"
                />
                <span class="ml10">{{ store.tname }}</span>
                <img
                  v-if="store.is_wyc == 1"
                  src="~@/assets/images/deal-manage/wyc.png"
                  width="209"
                  height="26"
                  style="margin-left: 10px"
                />
              </div>
            </td>
          </tr>
          <template v-for="spec in store.goods">
            <tr
              :key="spec.primary_type + '_' + spec.primary_id"
              class="tr_spec"
            >
              <td class="rel">
                <div class="flex_v_center">
                  <span v-if="spec.depot_id > 0" class="tag tag_circle tag_blue"
                    >仓</span
                  >
                  <img
                    :src="spec.goods_image"
                    width="60"
                    height="60"
                    class="ml10"
                    style="border-radius: 4px;"
                  />
                  <span
                    class="goods_name mult_ellipsis"
                    @click="toGoodsDetail(spec.encode_id)"
                    >{{ spec.goods_name }} {{ spec.spec_name }}</span
                  >
                </div>
                <div
                  v-if="method == 'order' && spec.bind != null"
                  class="tr_package" style="display: flex; align-items: center;background: #FAFAFA;"
                >
                  <td>
                    <div>{{ `【 捆绑包装】 ${spec.bind.name}` }}</div>
                  </td>
                  <td>
                    <div style="white-space: nowrap">{{ `¥ ${spec.bind.price} x ${spec.num}` }}</div>
                  </td>

                  <!-- <td>
                                <div>¥ {{ Number(spec.bind.price) * Number(spec.num) }}</div>
                            </td> -->
                </div>
              </td>
              <td>
                <span v-if="method == 'order' || method == 'mz'">
                  <span v-if="spec.is_plus == 1" class="price_plus"
                    >¥{{ Number(spec.vip_price).toFixed(2) }}
                  </span>
                  <span v-else>¥{{ getUnitPrice(spec) }} </span>
                  <img
                    v-if="spec.is_plus == 1"
                    src="~@/assets/images/basic/plus_price.png"
                    class="plus_price"
                  />
                  <p
                    class="price_plus"
                    v-if="spec.is_plus == 0 && spec.vip_price > 0"
                  >
                    会员 ¥{{ Number(spec.vip_price).toFixed(2) }}
                  </p>
                  <p
                    v-if="spec.discount_id > 0 && spec.discount != ''"
                    class="discount"
                  >
                    <a-popover
                      title="批发优惠"
                      placement="topRight"
                      trigger="click"
                    >
                      <template #content>
                        <p v-for="d in spec.discount.rule" :key="'sdr' + d.id">
                          订购{{ d.min }}-{{ d.max }}套，优惠¥{{
                            d.price
                          }}元/套
                        </p>
                      </template>
                      <p>
                        <img src="~@/assets/images/deal-manage/discount.png" />
                        {{ spec.discount.des }} -{{ spec.discount.price }}
                      </p>
                    </a-popover>
                  </p>
                </span>
                <span v-else>¥{{ getUnitPrice(spec) }}</span>
              </td>
              <td>
                <span
                  v-if="
                    method == 'depot' ||
                    method == 'byp_deposit' ||
                    method == 'byp_arrear' ||
                    spec.depot_id != 0 ||
                    method == 'mz'
                  "
                  >{{ spec.num }}</span
                >
                <input-number
                  v-else
                  :num="spec.num"
                  :max="spec.storage"
                  :spec="spec"
                  @changeCartNum="debounceChangeSpecNum($event, spec)"
                />
              </td>
              <td
                v-if="
                  method == 'order' || method == 'mz' || method == 'byp_arrear'
                "
              >
                <a-space
                  direction="vertical"
                  :size="10"
                  class="service_wrapper"
                >
                  <div v-if="method != 'mz'">
                    <div
                      v-for="item in sxbdpList"
                      :key="
                        'sxbdp' + spec.primary_id + spec.primary_type + item.id
                      "
                    >
                      <input
                        type="checkbox"
                        v-model="spec.sxbdp"
                        :id="
                          'sxbdp_' +
                          spec.primary_id +
                          '_' +
                          spec.primary_type +
                          '_' +
                          item.id
                        "
                        @change="
                          checkSxbdp(
                            $event,
                            store.id,
                            spec.primary_id,
                            spec.primary_type,
                            item.id
                          )
                        "
                      />
                      <label
                        :for="
                          'sxbdp_' +
                          spec.primary_id +
                          '_' +
                          spec.primary_type +
                          '_' +
                          item.id
                        "
                      >
                        <span>{{ item.name }}(剩余:{{ item.num||0 }})</span>
                        <span
                          :ref="
                            'sxbdp_' +
                            spec.primary_id +
                            '_' +
                            spec.primary_type +
                            '_' +
                            item.id
                          "
                          class="service_price"
                          >¥{{ item.price * spec.num }}</span
                        >
                      </label>
                    </div>
                  </div>

                  <!-- <a-row type="flex" align="middle" :gutter="10">
                                        <a-col :class="{'self_flex_start':spec.tag_id > 0}">
                                            <input type="checkbox" v-model="spec.tag" :id="'custom_tag_'+spec.id+'_'+spec.type" @change="e => checkCustomTag(spec,e)" />
                                            <label :for="'custom_tag_'+spec.id+'_'+spec.type" style="padding-left:15px;">&nbsp;</label>
                                        </a-col>
                                        <a-col style="padding-left:0px;">
                                            <span v-if="spec.tag == null" @click="ShowTagModal(spec)">自定义吊牌</span>
                                            <div v-else class="service_item_wrapper">
                                                <a-row type="flex" justify="end">
                                                    <a-col class="label" @click="ShowTagModal(spec)">自定义吊牌</a-col>
                                                </a-row>
                                                <a-row type="flex" align="middle" :gutter="10" class="item_wrapper">
                                                    <a-col flex="1" class="name">{{spec.tag.name}}</a-col>
                                                    <a-col class="service_price">¥{{spec.tag.price * spec.num}}</a-col>
                                                </a-row>
                                            </div>
                                        </a-col>
                                    </a-row> -->
                  <a-row
                    v-if="method != 'mz'"
                    type="flex"
                    align="middle"
                    :gutter="10"
                  >
                    <a-col :class="{ self_flex_start: spec.resize.length > 0 }">
                      <a-checkbox
                        :checked="spec.resize.length > 0 ? true : false"
                        @change="(e) => checkResize(spec, e)"
                      ></a-checkbox>
                    </a-col>
                    <a-col>
                      <span
                        v-if="spec.resize.length == 0"
                        @click="showSizeModal(spec)"
                        >修改尺寸</span
                      >
                      <div v-else class="service_item_wrapper">
                        <a-row type="flex" justify="end">
                          <a-col class="label" @click.stop="showSizeModal(spec)"
                            >修改尺寸</a-col
                          >
                        </a-row>
                        <a-row
                          type="flex"
                          align="middle"
                          :gutter="10"
                          class="item_wrapper"
                          v-for="item in spec.resize"
                          :key="item.id"
                        >
                          <a-col flex="1" class="name">{{
                            item.type_name
                          }}</a-col>
                          <a-col class="service_price_show"
                            >¥{{ item.price * spec.num }}</a-col
                          >
                        </a-row>
                      </div>
                    </a-col>
                  </a-row>
                  <a-row type="flex" align="middle">
                    <a-col>
                      <input
                        type="checkbox"
                        v-model="spec.gold_quality"
                        :id="
                          'gold_quality_' +
                          spec.primary_id +
                          '_' +
                          spec.primary_type
                        "
                        @change="
                          (e) => {
                            checkQuality(spec, e);
                          }
                        "
                      />
                      <label
                        :for="
                          'gold_quality_' +
                          spec.primary_id +
                          '_' +
                          spec.primary_type
                        "
                      >
                        <!--<img
                          src="~@/assets/images/basic/gold_quality.png"
                          width="74"
                          height="26"
                        />-->
                        <img
                          src="https://img3.91jf.com/qcloud/adv/20250424/20250424152125_2860947421.png"
                          width="64"
                          height="20"
                        />
                      </label>
                    </a-col>
                    <a-col>
                      <a
                        target="_blank"
                        class="flex"
                        href="https://detail.91jf.com/help/42"
                      >
                        <img
                          src="~@/assets/images/basic/ic_question.png"
                          width="14"
                          height="14"
                          class="point"
                        />
                      </a>
                    </a-col>
                    <a-col
                      :ref="
                        'quality_price_show_' +
                        spec.primary_id +
                        '_' +
                        spec.primary_type
                      "
                      class="service_price ml10"
                      >¥{{ spec.quality_price * spec.num }}</a-col
                    >
                  </a-row>
                </a-space>
              </td>
              <td>
                <span
                  :ref="
                    'goods_price_' + spec.primary_id + '_' + spec.primary_type
                  "
                  >¥{{ calcGoodsPrice(spec) }}</span
                >
              </td>
            </tr>
          </template>
          <tr
            v-if="method == 'order' || method == 'byp_arrear'"
            :key="`remark_${store.id + index}`"
            class="tr_remark"
          >
            <td colspan="6">
              <a-row type="flex" align="middle" class="buyer_remark">
                <a-col>买家留言：</a-col>
<!--                <a-col flex="0.366">-->
                <a-col flex="1">
                  <textarea
                    v-model="store.remark"
                    class="underline_input"
                    placeholder="选填：对本次交易的说明（建议填写已经和商家达成一致的说明）"
                  ></textarea>
                </a-col>
              </a-row>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <custom-tag-modal
      v-if="curSpec"
      v-model="isShowTagModal"
      :selectTag="curSpec.tag"
      @change="changeTag"
    />
    <resize-modal
      ref="resizeModal"
      v-if="curSpec"
      v-model="isShowResizeModal"
      :selectResize="curSpec.resize"
      @change="changeSize"
    />
    <notice-weight v-model="isNoticeWeightModal"></notice-weight>
  </div>
</template>

<script>
import InputNumber from "@/components/common/InputNumber";
import CustomTagModal from "@/components/common/order/CustomTagModal";
import ResizeModal from "@/components/common/order/ResizeModal";
import NoticeWeight from "@/components/common/NoticeWeight.vue";

export default {
  name: "SettleGoodsTable",
  props: {
    method: {
      type: String
    },
    address:{
      type: Object
    }
  },
  components: {
    CustomTagModal,
    ResizeModal,
    InputNumber,
    NoticeWeight
  },
  data() {
    return {
      isShowResizeModal: false,
      isShowTagModal: false,
      isNoticeWeightModal: false,
      curSpec: null,
      sxbdpList: [],
      goodsList: [],
      tagList: [],
      settleGoods: [],
      lastWeight: 0
    };
  },
  created() {
    this.initGoodsList();

    if (this.method == "order" || this.method == "byp_arrear") {
      this.getSxbdp();
    }
  },
  methods: {
    getUnitPrice(spec) {
      var res = parseFloat(spec.price);

      if (typeof spec.member_discount != "undefined") {
        res = res - parseFloat(spec.member_discount.price);
      }

            return Number(res).toFixed(2);
        },
        countWeight() {
            var data = JSON.parse(JSON.stringify(this.goodsList));
            var weight = 0;
            var is_alone = 0;
            var cat_ids = [];
            var total = 0;
            var goods = [];

      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].goods.length; j++) {
          weight =
            weight + parseFloat(data[i].goods[j].weight * data[i].goods[j].num);

          if (data[i].goods[j].bind != null) {
            weight =
              weight +
              parseFloat(data[i].goods[j].bind.weight * data[i].goods[j].num);
          }

          is_alone = is_alone + parseInt(data[i].goods[j].num);
          cat_ids.push(data[i].goods[j].catid);

                    if (data[i].goods[j].store_id != 9041) {
                        total = total + parseInt(data[i].goods[j].num);
                    }
                    goods.push(data[i].goods[j])
                }
            }
            // console.log(this.lastWeight,weight);
            if(weight >= 20 && !this.isNoticeWeightModal){
                this.isNoticeWeightModal = true;
            }

            if((this.lastWeight >= 20 && weight < 20) || (this.lastWeight < 20 && weight >= 20)){
                this.$emit('resetExpress');
            }
            // console.log(data,weight);
            this.lastWeight = weight;
            this.$emit('isAlone', is_alone);
            this.$emit('countWeight', weight);
            this.$emit('cats', cat_ids, total);
            this.$emit('goods', goods);
        },
        debounceChangeSpecNum(num, spec) {
            // console.log('print',num,spec)
            var data = this.goodsList;
            new Promise((reslose, reject) => {
                for (var i = 0; i < data.length; i++) {
                    var goods = null;

          for (var j = 0; j < data[i].goods.length; j++) {
            if (
              data[i].goods[j].primary_type == spec.primary_type &&
              data[i].goods[j].primary_id == spec.primary_id
            ) {
              data[i].goods[j].num = parseInt(num);

              if (data[i].goods[j].discount != "") {
                goods = data[i].goods[j];
              }

              break;
            }
          }

          if (goods != null) {
            data = this.getDiscount(
              goods.discount.rule,
              goods,
              JSON.parse(JSON.stringify(data))
            );
          }

          if (spec.primary_type == "cart") {
            this.$util.api(
              "/cart/change",
              {
                cart_id: spec.primary_id,
                num: num,
              },
              (res) => {
                reslose(res);
              }
            );
          } else if (spec.primary_type == "goods") {
            reslose(data);
          }
        }

        if (spec.primary_type == "goods") {
          var ids = [];

          for (var i = 0; i < data.length; i++) {
            var g = data[i].goods;

            for (var j = 0; j < g.length; j++) {
              ids.push(g[j].goods_id + "|" + g[j].spec_id + "|" + g[j].num);
            }
          }

          var query_param = {
            ...this.$route.query,
            ids: ids.join(","),
          }

          if (this.address.id) {
            query_param.address = this.address.id;
          }

          var address = this.address;
          this.$router
            .push({
              query: query_param
            })
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                throw err;
              }
            });
        }
      }).then((result) => {
        this.goodsList = data;
        this.goodsPrice(spec);
        // this.$emit('countWeight');
        this.countWeight();
      });
    },
    checkQuality(spec, e) {
      const { checked } = e.target;
      var data = this.goodsList;
      var key =
        "quality_price_show_" + spec.primary_id + "_" + spec.primary_type;

      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].goods.length; j++) {
          if (
            data[i].goods[j].primary_type == spec.primary_type &&
            data[i].goods[j].primary_id == spec.primary_id
          ) {
            data[i].goods[j].gold_quality = checked ? 1 : 0;
            break;
          }
        }
      }

      spec.gold_quality = checked ? 1 : 0;
      this.goodsList = data;
      this.$refs[key][0].$el.style.display = checked ? "inline-block" : "none";
      this.goodsPrice(spec);
      this.countWeight();
    },
    checkSxbdp(event, store_id, id, type, sxbdp_id) {
      if (sxbdp_id != null) {
        var data = this.goodsList;

        for (var i = 0; i < data.length; i++) {
          if (parseInt(data[i].id) == parseInt(store_id)) {
            for (var j = 0; j < data[i].goods.length; j++) {
              if (
                data[i].goods[j].primary_type == type &&
                parseInt(data[i].goods[j].primary_id) == parseInt(id)
              ) {
                var key = "sxbdp_" + id + "_" + type + "_" + sxbdp_id;

                if (event.target.checked) {
                  var flag = true;
                  var sxbdp = data[i].goods[j].sxbdp;

                  this.$refs[key][0].style.display = "inline-block";

                  for (var k = 0; k < data[i].goods[j].sxbdp.length; k++) {
                    if (
                      parseInt(data[i].goods[j].sxbdp[k]) == parseInt(sxbdp_id)
                    ) {
                      flag = false;
                      break;
                    }
                  }

                  if (flag) {
                    sxbdp.push(parseInt(sxbdp_id));
                  }
                } else {
                  var sxbdp = [];
                  this.$refs[key][0].style.display = "none";

                  for (var k = 0; k < data[i].goods[j].sxbdp.length; k++) {
                    if (
                      parseInt(data[i].goods[j].sxbdp[k]) != parseInt(sxbdp_id)
                    ) {
                      sxbdp.push(parseInt(data[i].goods[j].sxbdp[k]));
                    }
                  }
                }

                for (var k = 0; k < sxbdp.length; k++) {
                  if (sxbdp[k] == null || isNaN(sxbdp[k])) {
                    sxbdp.splice(k, 1);
                  }
                }

                data[i].goods[j].sxbdp = sxbdp;
                this.goodsPrice(data[i].goods[j]);
                break;
              }
            }

            break;
          }
        }

        this.goodsList = data;
        this.countWeight();
      }
    },
    goodsPrice(spec) {
      this.$refs[
        "goods_price_" + spec.primary_id + "_" + spec.primary_type
      ][0].innerHTML = "¥" + this.calcGoodsPrice(spec);
    },
    calcGoodsPrice(spec) {
      var total = 0;

      if (spec.primary_type != "depot" && parseInt(spec.depot_id) <= 0) {
        if (spec.is_plus == 1 && spec.vip_price > 0) {
          total = total + parseFloat(spec.vip_price * spec.num);
        } else {
          // var unit_price = spec.price;
          var unit_price = spec.count_price;

          if (typeof spec.member_discount != "undefined") {
            unit_price = unit_price - spec.member_discount.price;
          }

          if (
            typeof spec.discount != "undefined" &&
            typeof spec.discount.id != "undefined"
          ) {
            var discount_rules = spec.discount.rule;
            var discount_price = 0;

            for (var i = 0; i < discount_rules.length; i++) {
              if (
                discount_rules[i].min <= spec.num &&
                (discount_rules[i].max > spec.num || discount_rules[i].max == 0)
              ) {
                discount_price = parseFloat(discount_rules[i].price);
              }
            }

            unit_price = unit_price - discount_price;
          }

          total = total + parseFloat(unit_price * spec.num);
        }
      }

      if (this.method == "depot") {
        return total;
      }

      if (spec.sxbdp.length > 0) {
        for (var i = 0; i < spec.sxbdp.length; i++) {
          for (var j = 0; j < this.sxbdpList.length; j++) {
            if (parseInt(this.sxbdpList[j].id) == parseInt(spec.sxbdp[i])) {
              total = total + parseFloat(this.sxbdpList[j].price * spec.num);
            }
          }
        }
      }
      if (spec.tag != null) {
        total = total + parseFloat(spec.tag.price * spec.num);
      }

      if (spec.resize.length > 0) {
        for (var i = 0; i < spec.resize.length; i++) {
          total = total + parseFloat(spec.resize[i].price * spec.num);
        }
      }

      if (spec.gold_quality == 1) {
        total = total + parseFloat(spec.quality_price * spec.num);
      }

      if (spec.bind != null) {
        total = total + parseFloat(spec.bind.price * spec.num);
      }

      if (spec.voucher_price != null) {
        total = total - parseFloat(spec.voucher_price);
      }

      return total.toFixed(2);
    },
    checkCustomTag(spec, e) {
      const { checked } = e.target;

      if (checked) {
        this.ShowTagModal(spec);
      } else {
        var data = this.goodsList;

        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < data[i].goods.length; j++) {
            if (
              data[i].goods[j].type == spec.type &&
              data[i].goods[j].id == spec.id
            ) {
              data[i].goods[j].tag = null;
              this.goodsPrice(data[i].goods[j]);
              break;
            }
          }
        }

        spec.tag = null;
        this.goodsList = data;
        this.countWeight();
      }
    },
    ShowTagModal(spec) {
      this.curSpec = spec;
      this.isShowTagModal = true;
    },
    checkResize(spec, e) {
      const { checked } = e.target;

      if (checked) {
        this.showSizeModal(spec);
      } else {
        spec.resize = [];
      }

      this.goodsPrice(spec);
      this.countWeight();
    },
    changeTag(tag) {
      var data = this.goodsList;
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].goods.length; j++) {
          if (
            data[i].goods[j].type == this.curSpec.type &&
            data[i].goods[j].id == this.curSpec.id
          ) {
            data[i].goods[j].tag = tag;
            this.goodsPrice(data[i].goods[j]);
            break;
          }
        }
      }
      this.curSpec.tag = tag;
      this.goodsList = data;
    },
    showSizeModal(spec) {
      this.curSpec = spec;
      this.isShowResizeModal = true;
      this.$nextTick(() => {
        this.$refs.resizeModal.specInfo = spec;
        this.$refs.resizeModal.checkType();
      });
    },
    changeSize(sizeList) {
      var data = this.goodsList;

      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].goods.length; j++) {
          if (
            data[i].goods[j].primary_type == this.curSpec.primary_type &&
            data[i].goods[j].primary_id == this.curSpec.primary_id
          ) {
            data[i].goods[j].resize = sizeList;
            break;
          }
        }
      }

      this.curSpec.resize = sizeList;
      this.goodsList = data;
      this.goodsPrice(this.curSpec);
      this.countWeight();
    },
    countPrice() {
      var res = 0;
      var goods = this.goodsList;

      for (var i = 0; i < goods.length; i++) {
        var g = goods[i].goods;

        for (var j = 0; j < g.length; j++) {
          res = res + parseFloat(g[j].pay_price) * g[j].num;
        }
      }

      this.$emit("getPrice", res);
    },
    getGoodsList() {
      var cart_ids = [];
      var depot_ids = [];
      var goods = [];

      if (this.method == "mz") {
        goods = this.settleGoods;
      } else {
        if (this.$route.query.type == "cart") {
          cart_ids = this.$route.query.ids.split(",");
        } else if (this.$route.query.type == "depot") {
          depot_ids = this.$route.query.ids.split(",");
        } else if (this.$route.query.type == "goods") {
          var ids = this.$route.query.ids.split(",");

          for (var i = 0; i < ids.length; i++) {
            var arr = ids[i].split("|");

            goods.push({
              goods_id: arr[0],
              spec_id: arr[1],
              buy_num: arr[2],
            });
          }
        }
      }

      this.$util.api(
        "/order/settle",
        {
          cart_ids: cart_ids.join(","),
          depot_ids: depot_ids.join(","),
          goods: JSON.stringify(goods),
          byp_id:
            this.$route.query.byp_id == null ? "" : this.$route.query.byp_id,
        },
        (res) => {
          if (res.code == 10000) {
            var data = res.data;
            var flag = true;
            var cat_ids = [];
            var total = 0;

            if (data.length <= 0) {
              this.$message.error("请至少选择一个结算商品");
              this.$router.push("/cart");
              return false;
            }

            for (var i = 0; i < data.length; i++) {
              data[i].remark = "";

              for (var j = 0; j < data[i].goods.length; j++) {
                data[i].goods[j].sxbdp = [];
                data[i].goods[j].tag = null;
                data[i].goods[j].resize = [];
                data[i].goods[j].gold_quality = 0;
                data[i].goods[j].count_price = data[i].goods[j].price;
                data[i].goods[j].count_vip_price = data[i].goods[j].vip_price;

                if (data[i].goods[j].discount != "") {
                  // data[i].goods[j] = this.getDiscount(data[i].goods[j].discount.rule,data[i].goods[j],JSON.parse(JSON.stringify(data)));
                  this.getDiscount(
                    data[i].goods[j].discount.rule,
                    data[i].goods[j],
                    JSON.parse(JSON.stringify(data))
                  );
                  flag = false;
                }

                cat_ids.push(data[i].goods[j].catid);

                if (data[i].goods[j].store_id != 9041) {
                  total = total + parseInt(data[i].goods[j].num);
                }
              }
            }

            if (flag) {
              this.goodsList = data;
            }

            this.countPrice();
            this.countWeight();
            this.checkCloudHouse();
            this.getDefaultGift();
            this.$emit("cats", cat_ids, total);
          } else {
            this.$message.error(res.msg);
            // this.$router.push('/cart');
            this.$router.go(-1);
          }
        }
      );
    },
    initGoodsList() {
      if (this.method == "mz") {
        if (this.$route.query.id == null) {
          this.$message.error("未指定订单ID");
          this.$router.go(-1);

          return false;
        }

        this.$util.api(
          "/mz/info",
          {
            id: this.$route.query.id,
          },
          (res) => {
            if (res.code == 10000) {
              var goods = [];

              for (var i = 0; i < res.data.goods.length; i++) {
                goods.push({
                  goods_id: res.data.goods[i].goods_id,
                  spec_id: res.data.goods[i].spec_id,
                  buy_num: res.data.goods[i].num,
                });
              }

              this.settleGoods = goods;
              this.getGoodsList();
              this.$emit(
                "syncReceive",
                res.data.receive,
                res.data.sn,
                res.data.mask_receive,
                res.data.send_info,
                res.data.express
              );
            } else {
              this.$message.error(res.msg);
              this.$router.go(-1);
            }
          }
        );
      } else {
        this.getGoodsList();
      }
    },
    getDefaultGift() {
      var goods = this.goodsList;
      var price = 0;
      var res = 0;
      var cats = [];

      for (var i = 0; i < goods.length; i++) {
        for (var j = 0; j > goods[i].goods.length; j++) {
          price = price + goods[i].goods[j].pay_price * goods[i].goods[j].num;
          cats.push(parseInt(goods[i].goods[j].catid));
        }
      }

      if (price < 150) {
        res = 751816;
      } else {
        res = 232538;
      }

      for (var i = 0; i < cats.length; i++) {
        if (this.$util.inArray(cats[i], [304, 305, 306, 308, 311, 312, 323])) {
          res = 76712;
          break;
        }
      }

      this.$emit("defaultPackage", res);
    },
    getDiscount(rule, spec, data) {
      var num = 0;
      var used = null;

      for (var i = 0; i < data.length; i++) {
        var goods = data[i].goods;

        for (var j = 0; j < goods.length; j++) {
          if (goods[j].goods_id == spec.goods_id) {
            num = parseInt(num) + parseInt(goods[j].num);
          }
        }
      }

      for (var i = 0; i < rule.length; i++) {
        if (rule[i].min <= num && (rule[i].max > num || rule[i].max == 0)) {
          used = rule[i];

          break;
        }
      }

      for (var i = 0; i < data.length; i++) {
        var goods = data[i].goods;

        for (var j = 0; j < goods.length; j++) {
          if (typeof data[i].goods[j].sxbdp == "undefined") {
            data[i].goods[j].sxbdp = [];
          }

          if (typeof data[i].goods[j].tag == "undefined") {
            data[i].goods[j].tag = null;
          }

          if (typeof data[i].goods[j].resize == "undefined") {
            data[i].goods[j].resize = [];
          }

          if (typeof data[i].goods[j].gold_quality == "undefined") {
            data[i].goods[j].gold_quality = 0;
          }

          if (typeof data[i].goods[j].count_price == "undefined") {
            data[i].goods[j].count_price = data[i].goods[j].price;
          }

          if (typeof data[i].goods[j].count_vip_price == "undefined") {
            data[i].goods[j].count_vip_price = data[i].goods[j].vip_price;
          }

          if (goods[j].discount != "") {
            var des = "";

            if (goods[j].goods_id == spec.goods_id && used != null) {
              goods[j].discount_id = used.id;
              goods[j].discount.price = used.price;

              if (used.min > 0) {
                des += ">=" + used.min + "套 ";
              }

              if (used.max > 0) {
                des += "<" + used.max + "套";
              }
            }

            if (des == "") {
              goods[j].discount.price = rule[0].price;
              goods[j].discount_id = rule[0].id;
              des = ">=" + rule[0].min + "套 " + "<" + rule[0].max + "套";
            }

            goods[j].discount.des = des;
          }

          if (goods[j].discount != "" && used != null) {
            goods[j].price = goods[j].count_price - goods[j].discount.price;
            goods[j].vip_price =
              goods[j].count_vip_price - goods[j].discount.price;
          } else {
            goods[j].price = goods[j].count_price;
            goods[j].vip_price = goods[j].count_vip_price;
          }

          goods[j].vip_price = goods[j].vip_price <= 0 ? 0 : goods[j].vip_price;

          // if(goods[j].goods_id == spec.goods_id && goods[j].spec_id == spec.spec_id && goods[j].primary_type == spec.primary_type && goods[j].primary_id == spec.primary_id){
          //     spec = goods[j];
          // }
        }
      }

      this.goodsList = data;
      // console.log(data);
      return data;
    },
    checkCloudHouse() {
      var req = [];

      for (var i = 0; i < this.goodsList.length; i++) {
        var goods = this.goodsList[i].goods;

        for (var j = 0; j < goods.length; j++) {
          if (goods[j].primary_type != "depot") {
            req.push({
              goods_id: goods[j].goods_id,
              spec_id: goods[j].spec_id,
              num: goods[j].num,
            });
          }
        }
      }

      this.$util.api(
        "/order/cloud",
        {
          data: JSON.stringify(req),
        },
        (res) => {
          this.$emit("checkCloudHouse", res.code == 10000 ? true : false);
        }
      );
    },
    getSxbdp() {
      var _this = this;

      _this.$util.api("/tag/sxbdp", {}, function (res) {
        if (res.code == 10000) {
          _this.sxbdpList = res.data;
        }
      });
    },
    toGoodsDetail(id) {
      window.open("https://detail.91jf.com/goods/" + id, "_blank");
    },
  },
};
</script>

<style scoped>
.discount {
  color: #ff8300;
  cursor: pointer;
  text-align: center;
}

.discount img {
  width: 44px;
  height: 16px;
  vertical-align: -5%;
}

.price_plus {
  color: #cc8e52;
}

.plus_price {
  width: 45px;
  height: 18px;
}

.ant-table-thead th {
  text-align: center;
  font-size: 16px;
  background: #fafafa;
  font-weight: 400;
}

.tr_spec {
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}

.tr_spec:hover {
  box-shadow: 5px 5px 10px #00000020;
}

.ant-table-tbody td {
  text-align: center;
}

.tr_package {
  width: 100%;
}

.tr_package td {
  padding: 0;
}

.tr_package td:first-child {
  text-align: left;
  /* padding-left: 15px; */
}

.tr_package td:last-child {
  padding-right: 15px;
}

.tr_package td > div {
  padding: 9px 15px;
  background: #fafafa;
}

.goods_name {
  text-align: left;
  cursor: pointer;
  margin-left: 10px;
}

.goods_name:hover {
  color: #fd5902;
}

.tag {
  display: inline-block;
  margin-left: 10px;
  text-align: center;
  color: #ffffff;
  font-size: 10px;
}

.tag_circle {
  min-width: 18px;
  height: 18px;
  border-radius: 50%;
  line-height: 16px;
}

.tag_blue {
  background: #027fff;
}

.service_wrapper {
  align-items: flex-start;
}

.service_wrapper ::v-deep .ant-btn {
  padding: 5px 10px;
}

.service_wrapper > div {
  text-align: left;
}

.service_price_show {
  font-weight: bold;
}

.service_price {
  font-weight: bold;
  display: none;
}

.service_item_wrapper {
  //width: 176px;
  width: 140px;
  background: #fffefb;
  border: 1px solid #ffe5ca;
}

.service_item_wrapper .item_wrapper {
  padding: 8px 10px;
}

.service_item_wrapper .item_wrapper .name {
  color: #666666;
  text-align: left;
}

.service_item_wrapper .label {
  display: inline-block;
  margin-bottom: 5px;
  padding: 5px 10px;
  background: #fff4e8;
  color: #fd5902;
  font-size: 12px;
  cursor: pointer;
}

::v-deep .ant-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.buyer_remark {
  padding: 10px;
  margin-top: 10px;
}

.pack_wrapper {
  position: absolute;
  bottom: 20px;
  left: 20px;
}

.self_flex_start {
  align-self: flex-start;
}

>>> .ant-checkbox-inner {
  border-color: #bebebe;
}

>>> .ant-table-tbody > tr > td {
  border-bottom-color: #f4f4f4;
}

.underline_input {
  width: 100%;
  height: 32px;
  border: 1px solid #d9d9d9;
  padding: 4px 11px;
  box-sizing: border-box;
  outline: none;
  resize: none;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.underline_input::placeholder {
  color: #bfbfbf;
}
</style>



// WEBPACK FOOTER //
// src/components/common/order/SettleGoodsTable.vue